@if(isElectron()) {
<section class="windowTitleBar drag-region text-center"></section>
<div id="window-controls">
    <div class="button" id="min-button" onclick="window.windowControls.minimize();">
        <span>&#xE921;</span>
    </div>
    <div class="button" id="max-button" onclick="window.windowControls.maximize()">
        <span>&#xE922;</span>
    </div>
    <div class="button" id="restore-button" onclick="window.windowControls.restore()">
        <span>&#xE923;</span>
    </div>
    <div class="button" id="close-button" onclick="window.windowControls.close()">
        <span>&#xE8BB;</span>
    </div>
</div>
}

<router-outlet />
<app-toaster></app-toaster>